/**
 * Number formatting utility functions
 */

/**
 * Formats a number with locale-specific thousands separators
 * @param num - The number to format
 * @returns The formatted number as a string
 */
export function formatNumber(num: number): string {
  return num.toLocaleString();
}

/**
 * Formats file size in bytes to human-readable format
 * @param bytes - The file size in bytes
 * @returns The formatted file size string (e.g., "1.5 MB")
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1);
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}
